import * as echarts from "echarts/core";
import { AXIS_TEXT_COLOR } from "../utils/chartConstants";
import { formatNumericValue, getChartDataset, LINE_CHART_SMOOTH_INTENSITY, parseNumericValue, resolveLabelAndValueKeys, } from "../../../utils/chartData";
export function buildSimpleLineOption(data, isMobile) {
    var _a;
    var dataset = getChartDataset(data);
    var _b = resolveLabelAndValueKeys(data, dataset), labelKey = _b.labelKey, valueKey = _b.valueKey;
    var labels = dataset.map(function (item) { return item[labelKey]; });
    var values = dataset.map(function (item) { var _a; return parseNumericValue((_a = item[valueKey]) !== null && _a !== void 0 ? _a : item.value); });
    var shouldRotateLabels = labels.length > 6 ||
        labels.some(function (label) { return label != null && String(label).length > 10; });
    return {
        tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,0.96)",
            borderColor: "#ECEEF4",
            borderWidth: 1,
            textStyle: {
                fontFamily: "Montserrat, sans-serif",
                color: "#374151",
                fontSize: 13,
            },
            extraCssText: "box-shadow: 0 4px 20px rgba(0,0,0,0.08); border-radius: 10px;",
            formatter: function (params) {
                var _a, _b, _c, _d, _e;
                if (Array.isArray(params)) {
                    var axisLabel = (_d = (_b = (_a = params[0]) === null || _a === void 0 ? void 0 : _a.axisValueLabel) !== null && _b !== void 0 ? _b : (_c = params[0]) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "";
                    if (params.length === 1) {
                        return "<strong>".concat(axisLabel, "</strong><br/><strong>").concat(formatNumericValue((_e = params[0]) === null || _e === void 0 ? void 0 : _e.value), "</strong>");
                    }
                    var rows = params.map(function (item) {
                        var _a, _b, _c;
                        var marker = (_a = item.marker) !== null && _a !== void 0 ? _a : "";
                        var seriesName = (_c = (_b = item.seriesName) !== null && _b !== void 0 ? _b : item.name) !== null && _c !== void 0 ? _c : "";
                        return "".concat(marker).concat(seriesName, ": <strong>").concat(formatNumericValue(item.value), "</strong>");
                    });
                    return "<strong>".concat(axisLabel, "</strong><br/>").concat(rows.join("<br/>"));
                }
                return "<strong>".concat(params.name, "</strong><br/><strong>").concat(formatNumericValue(params.value), "</strong>");
            },
        },
        grid: {
            left: isMobile ? "2%" : "3%",
            right: isMobile ? "3%" : "4%",
            bottom: shouldRotateLabels
                ? isMobile ? "18%" : "16%"
                : isMobile ? "6%" : "3%",
            top: "10%",
            containLabel: true,
        },
        xAxis: {
            type: "category",
            data: labels,
            axisLabel: {
                fontFamily: "Montserrat, sans-serif",
                fontSize: 11,
                color: AXIS_TEXT_COLOR,
                interval: 0,
                rotate: shouldRotateLabels ? (isMobile ? 28 : 34) : 0,
            },
            axisLine: { lineStyle: { color: "#E5E7EB" } },
            axisTick: { show: false },
        },
        yAxis: {
            type: "value",
            axisLabel: {
                fontFamily: "Montserrat, sans-serif",
                fontSize: 11,
                color: AXIS_TEXT_COLOR,
                formatter: function (value) { return formatNumericValue(value); },
            },
            splitLine: { lineStyle: { color: "#F3F4F6", type: "dashed" } },
        },
        series: [
            {
                type: "line",
                data: values,
                smooth: LINE_CHART_SMOOTH_INTENSITY,
                symbol: "circle",
                symbolSize: isMobile ? 10 : 8,
                lineStyle: { color: "#034EA2", width: isMobile ? 4 : 3 },
                itemStyle: {
                    color: "#034EA2",
                    borderColor: "#fff",
                    borderWidth: 2,
                },
                areaStyle: ((_a = echarts.graphic) === null || _a === void 0 ? void 0 : _a.LinearGradient)
                    ? {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: "rgba(3, 78, 162, 0.25)" },
                            { offset: 1, color: "rgba(3, 78, 162, 0.02)" },
                        ]),
                    }
                    : { color: "rgba(3, 78, 162, 0.15)" },
            },
        ],
    };
}
